import { pullAll, difference } from 'lodash';

export default function getInitialSplits(row, requiredSplits) {
  const initialSplits = row ? [...row.splits] : [];
  if (row) pullAll(initialSplits, difference(row.splits, requiredSplits));

  return initialSplits;
}
